export const iconFontAwesomeReligionBookQuran = (
	<i className="fa-solid fa-book-quran"></i>
);
